import React from "react";
import ICONS from "../../constants/icons";

import { Wrapper } from "./components";

const RatingStars = ({ rating = 5 }) => {
  return (
    <Wrapper>
      {[...new Array(rating)]?.map((a, i) => (
        <ICONS.Star key={i} />
      ))}
      {[...new Array(5 - rating)]?.map((a, i) => (
        <ICONS.Star color="#797680" key={5 - i} />
      ))}
    </Wrapper>
  );
};

export default RatingStars;
